<template>
    <div class="banner-image-area feature-app-landing drak-area section-space--pb_120">
        <div class="container_fl">
            <div class="row align-items-center">
                <div class="col-lg-6 order-1 order-lg-1 wow move-up">
                    <div class="banner-image__media">
                        <img src="../assets/img/features/aeroland-app-landing-image-04.png" class="img-fluid" alt="">
                    </div>
                </div>
                <div class="col-lg-6 order-2 order-lg-2">
                    <div class="app-landing__content">
                        <div class="app-landing__inner">
                            <h2 class="font-weight--bold mb-20 wow move-up">All Functional <br> Features Included</h2>
                            <div class="sub-text text section-space--mb_40 wow move-up">
Download the App:
<br> Available on both iOS and Android platforms.<br>
 Create Your Profile: <br>Sign up, set your preferences, and start exploring.<br>
Browse Categories: <br>Navigate through different categories like foods, movies, and games.<br>
Upload Your Experiences:<br> Share your experiences with the community by posting your reviews and photos.<br>
Engage and Connect: <br>Interact with other users by liking, commenting, and following their posts.                            </div>
                           
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default{
        name: 'BannerTwo',
    };
</script>

<style lang="scss">

</style>






